/*
 * @Author: wanxiaodong
 * @Date: 2019-12-30 14:05:18
 * @Last Modified by: wanxiaodong
 * @Last Modified time: 2020-01-17 10:35:39
* @Description:
 */
import React, {Component} from 'react'
import {Layout} from 'antd'
import InfoBlock from '../components/info-block'
import data from '../asserts/config/data'
import {BlockInter} from '../types/content'
import FooterInfo from '../components/footer'
import WaterMark from '../components/watermark'

import '../asserts/style/pages/index.less'
const { Content, Footer } = Layout


class IndexPage extends Component {
    state = data
    constructor(props: any) {
        super(props);
    };
    render() {
        return <Layout style={{background: '#fff'}}>
            <WaterMark />
            <Content style={{padding: '20px 0'}}>
                <div className="container">
                    {this.state.content.map((item:BlockInter, index: number) => {
                        return <InfoBlock blockInfo={item} key={index}/>
                    })}
                </div>
            </Content>
            <Footer style={{background: '#fff', borderTop: '1px solid #e0e0e0'}}>
                <FooterInfo/>
            </Footer>
        </Layout>
    }
}
export default IndexPage